<template>
  <sui-form-fields :error="isInvalid">
    <sui-form-field :width="10">
      <label>Address</label>
      <div class="ui labeled input">
        <input v-model="address" placeholder="example.com" />
      </div>
      <small class="errors">
        {{error}}
      </small>
    </sui-form-field>
    <sui-form-field :width="6">
      <label>Port</label>
      <div class="ui labeled input">
        <div class="ui label button dropdown" @click="togglePort()">
          <div class="text">{{protocol.toUpperCase()}}</div>
          <i class="dropdown icon" />
        </div>
        <input v-model.number="port" type="number" min="1" max="65535" :placeholder="field.placeholder" />
      </div>
    </sui-form-field>
  </sui-form-fields>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormProviderPort',
    mixins: [
      FormField,
    ],
    data() {
      const valueMatch = this.$attrs.value.match(/(udp|tcp):\/\/([^:]*):(\d+)/i) || ['', 'udp', '', '12201']
      return {
        protocol: valueMatch[1].toLowerCase(),
        address: valueMatch[2],
        port: parseInt(valueMatch[3]),
      }
    },
    watch: {
      address() {
        this.onChange()
      },
      port() {
        this.onChange()
      },
      protocol() {
        this.onChange()
      },
    },
    methods: {
      togglePort() {
        this.protocol = this.protocol === 'tcp' ? 'udp' : 'tcp'
      },
      onChange() {
        this.$attrs.value = `${this.protocol}://${this.address}:${this.port}`
        this.onInput()
      },
    },
  }
</script>

<style scoped>
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
